export class AuthExchangeGeneration {
  private generation = 0;

  capture() { return this.generation; }

  invalidate() {
    this.generation += 1;
  }

  applyIfCurrent(capturedGeneration: number, apply: () => void) {
    if (capturedGeneration !== this.generation) return false;
    apply();
    return true;
  }
}
